export interface GoodbyeSendResult {
  success?: boolean;
  skipped?: boolean;
  reason?: string;
  error?: string;
  code?: string;
  missingFields?: string[];
  failureAlertSent?: boolean;
  /** No sender body was received (network error, timeout, unreadable reply): delivery is unknown. */
  transportFailure?: boolean;
}
/** Supabase returns non-2xx response bodies on the error context, not in data. */
export async function readGoodbyeSendResult(
  data: GoodbyeSendResult | null | undefined,
  error: unknown
): Promise<GoodbyeSendResult> {
  if (error) {
    const context = typeof error === 'object' && error !== null && 'context' in error
      ? error.context
      : null;
    if (context instanceof Response) {
      try {
        const body = await context.clone().json();
        if (body && typeof body === 'object') {
          return { ...body, success: false };
        }
      } catch { /* Keep the transport failure if the response is not JSON. */ }
    }
    return {
      success: false,
      transportFailure: true,
      error: error instanceof Error ? error.message : 'The borrower notice did not send.'
    };
  }
  return data ?? { success: false, transportFailure: true, error: 'No response from the letter sender.' };
}

export function goodbyeFailureDescription(description: string, result: GoodbyeSendResult): string {
  return result.failureAlertSent === true
    ? `${description} The servicing team has been emailed.`
    : description;
}
